import { useEffect } from "react";

export default function useOutsideInteraction(ref, isActive, onOutside) {
  useEffect(() => {
    if (!isActive) return undefined;

    const handlePointer = (event) => {
      if (!ref.current || ref.current.contains(event.target)) return;
      onOutside?.();
    };

    document.addEventListener("mousedown", handlePointer);
    document.addEventListener("touchstart", handlePointer);

    return () => {
      document.removeEventListener("mousedown", handlePointer);
      document.removeEventListener("touchstart", handlePointer);
    };
  }, [isActive, onOutside, ref]);
}
